import { render, staticRenderFns } from "./HubTotal.vue?vue&type=template&id=6dc25284&lang=pug&"
import script from "./HubTotal.vue?vue&type=script&lang=ts&"
export * from "./HubTotal.vue?vue&type=script&lang=ts&"
import style0 from "./HubTotal.vue?vue&type=style&index=0&id=6dc25284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports